import { useCallback } from 'react';
import isNil from 'lodash/isNil';
import { toggleChartSettingsSliceAction } from '../../../redux/slices/analyses';
import { useAppDispatch } from '../../../redux/hooks';
import toastMessage from '../../../utils/toastMessage';
import { CHART_GROUPS_MAX_COUNT } from '../constants/utils';
import { useChartContext } from '../ChartContext';

const useToggleSlice = (analysisId: string) => {
  const dispatch = useAppDispatch();
  const {
    displayedSlices,
    metadata: { comparisonInfo },
  } = useChartContext();

  const activeSliceLimit = isNil(comparisonInfo?.comparisonConfig)
    ? CHART_GROUPS_MAX_COUNT
    : // in comparison mode all slices have a separate comparison slice
      CHART_GROUPS_MAX_COUNT / 2;

  return useCallback(
    (sliceKey: string, isVisible: boolean) => {
      if (
        !isVisible &&
        displayedSlices.filter((displayedSlice) => displayedSlice.isVisible)
          .length >= activeSliceLimit
      ) {
        toastMessage({
          message: `You've reached the maximum number of groups. Unselect a group to proceed.`,
          type: 'error',
        });
        return;
      }

      dispatch(toggleChartSettingsSliceAction({ analysisId, sliceKey }));
    },
    [activeSliceLimit, analysisId, dispatch, displayedSlices],
  );
};

export default useToggleSlice;
